<template>
    <div class="button-export" v-tooltip.left="{content:'Exportar'}">
      <b-dropdown right dropup id="dropdown-export" variant="button" class="m-2 p-0" no-caret>
        <template #button-content>
          <i class="mdi mdi-file-download"></i>
        </template>

        <b-dropdown-item
            href="#" 
            class="pr-10 pl-10 b-drop-options"
            variant="text"
            @click="$emit('export-pdf')"
          >
          <i 
              class="mdi mdi-file-pdf-box pl-2" 
              style="font-size:1.8rem; color:var(--medium-blue)"
            ></i>
            PDF           
          </b-dropdown-item>

          <b-dropdown-item
            v-if="print"
            href="#"
            class="pr-10 pl-10 b-drop-options"
            @click="$emit('print')"
          >
            <i class="mdi mdi-printer pl-2" style="font-size:1.8rem; color:var(--medium-blue)"></i>
            Imprimir
          </b-dropdown-item>

          <b-dropdown-item
            href="#" 
            class="pr-10 pl-10 b-drop-options"
            variant="text"
            v-if="excel"
          >
            <download-excel
              :name="getTitle"
              :fields="headers"
              :data="data"
            >
            <i 
                class="mdi mdi-file-excel pl-2" 
                style="font-size:1.6rem; color:var(--medium-blue)"
              ></i>
              EXCEL             
            </download-excel>
          </b-dropdown-item>
      </b-dropdown>
    </div>
</template>

<script>
import {BDropdown, BDropdownItem} from "bootstrap-vue";

export default {
  name:"ButtonExport",
  props:{
    excel:Boolean,
    print:Boolean,
    title: String,
    headers: Object,
    data: Array,
  },
  components:{
    BDropdown,
    BDropdownItem
  },
  computed:{
     getTitle() {
      let { title } = this;
      title = title
      .split(' ')
      .join('_')
      .toLowerCase();
      return `${title}_${Date.parse(new Date())}.xls`;
    },
  }
}
</script>

<style scoped>
  .button-export {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 90;
    background: var(--jersey-yellow);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 6px 18px rgba(185, 131, 0, .45);
    transition: transform .15s ease, box-shadow .15s ease, background-color .15s ease;
  }
  .button-export:hover {
    transform: translateY(-2px) scale(1.05);
    background: var(--jersey-yellow-dark);
    box-shadow: 0 10px 24px rgba(185, 131, 0, .5);
  }
  .button-export > .dropdown > ::v-deep .btn {
    color: white !important;
  }
  i {
    color: white;
    font-size: 1.7rem;
  }
  .dropdown-item i {
    font-size: 1.5rem;
  }
</style>
